export const messagesToIgnore = [
  'Please verify your Phone number',
  'Your account has been temporarily locked',
  'There was an unexpected error attempting to send the verification code, please try again later.',
  'There was an error attempting to verify the code. Please click "Re-send" and try again.',
  'There was an error attempting to verify the code. Please re-send it.',
  'There was an unexpected error attempting to verify the code. Please try again.',
  'There was an unexpected error during account creation. Please try again.',
  'Object captured as promise rejection with keys: fieldErrors, globalErrors',
  'Error: Unauthorized',
  'Error: Vehicle not found with plate',
  'Error: Vehicle details not found',
];
